import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function fetchLiveClassRecordings(response) {
  return {
    type: types.LIVE_CLASS_RECORDINGS,
    response,
  };
}
export function LiveClassRecordingsPlayer(response) {
  return {
    type: types.LIVE_CLASS_RECORDINGS_PLAYER,
    response,
  };
}

export const fetchLiveClassRecordingsData = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/dc/student/recordinglist';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      console.log(data);
      dispatch(fetchLiveClassRecordings(data));
    });
};

export const fetchRecordingsVideoData = async (
  uniqueCode,
  moduleCode,
  jwtToken,
  dispatch,
) => {
  const body = {
    UniqueCode: uniqueCode,
  };
  if (moduleCode) {
    body.ModuleCode = moduleCode;
  }
  const url = 'api/dc/student/recordingplayer';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      // onVideoAnalytics(data.data);
      dispatch(LiveClassRecordingsPlayer(data));
    });
};
